import Service from './Service'
import { ADV } from './apiUrls'

export default class AdvService extends Service {
  getShares (id, query) {
    return this.axios.get(`${ADV}/${id}/shares`, { params: query })
  }

  getNotes (id, query) {
    return this.axios.get(`${ADV}/${id}/notes`, { params: query })
  }

  postNote (id, data) {
    return this.axios.post(`${ADV}/${id}/notes`, data)
  }

  getOneShare (id, sellerId, query) {
    return this.axios.get(`${ADV}/${id}/shares/${sellerId}`, { params: query })
  }

  postShare (id, data) {
    return this.axios.post(`${ADV}/${id}/shares`, data)
  }

  patchShare (id, sellerId, data) {
    return this.axios.patch(`${ADV}/${id}/shares/${sellerId}`, data)
  }

  putShare (id, sellerId, data) {
    return this.axios.put(`${ADV}/${id}/shares/${sellerId}`, data)
  }

  getProcedureList (id) {
    return this.axios.get(`${ADV}/${id}/procedures`)
  }

  getProcedure (id, proceduresId) {
    return this.axios.get(`${ADV}/${id}/procedures/${proceduresId}`)
  }

  postProcedure (id) {
    return this.axios.post(`${ADV}/${id}/procedures`)
  }

  deleteProcedure (id, proceduresId, data) {
    return this.axios.put(`${ADV}/${id}/procedures/${proceduresId}`, data)
  }

  deleteShare (id, sellerId, data) {
    return this.axios.delete(`${ADV}/${id}/shares/${sellerId}`)
  }

  getComments (id) {
    return this.axios.get(`${ADV}/${id}/comments`)
  }

  postComment (id, data) {
    return this.axios.post(`${ADV}/${id}/comments`, data)
  }

  deleteComment (id, commentId) {
    return this.axios.delete(`${ADV}/${id}/comments/${commentId}`)
  }

  patchComment (id, commentId, data) {
    return this.axios.patch(`${ADV}/${id}/comments/${commentId}`, data)
  }

  postLre (id, data) {
    return this.axios.post(`${ADV}/${id}/lre`, data)
  }

  getAdfLre (id) {
    return this.axios.get(`${ADV}/${id}/adf-lre`)
  }

  postAdfLre (id, data) {
    return this.axios.post(`${ADV}/${id}/adf-lre`, data)
  }

  deleteAdfLre (id, adfId) {
    return this.axios.delete(`${ADV}/${id}/adf-lre/${adfId}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/AdvService.js